export default __webpack_public_path__ + "static/media/prologue-clock-negative.3bfe7e4b.png";